module.exports = __webpack_public_path__ + "static/media/documentation.e284211a.md";